import { BasicCard, BasicCardProps } from '../basic-card';

export type ChoosePlanProps = {
  cards: BasicCardProps[];
  perRow?: number;
  heading?: string;
};
export const ChoosePlan = (props: ChoosePlanProps) => {
  const perRow = props.perRow || 3;
  return (
    <div className="bg-surface-grey pb-12">
      <article className="container">
        <h2 className="lg:heading-3 heading-4 py-12 text-center">
          {props.heading ? props.heading : 'How to choose your plan?'}
        </h2>
        <div className={`gap-3 lg:grid grid-cols-${perRow} flex gap-x-2 overflow-x-auto lg:overflow-hidden`}>
          {props.cards.map((cardData, idx) => {
            return <BasicCard key={idx} {...cardData} className="min-w-[85%] lg:w-full" />;
          })}
        </div>
      </article>
    </div>
  );
};

export default ChoosePlan;
